import { render, staticRenderFns } from "./ExpressCreationDestinations.vue?vue&type=template&id=231f07aa&"
import script from "./ExpressCreationDestinations.vue?vue&type=script&lang=js&"
export * from "./ExpressCreationDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports